// src/components/TrackerService.js
import { collection, addDoc } from "firebase/firestore";
import { db } from "../services/firebase";

export const trackVisitor = async (visitorData) => {
    try {
        await addDoc(collection(db, "visitors"), visitorData);
    } catch (error) {
        console.error("Error saving visitor data to Firestore:", error);
    }
};

export const saveMessage = async (messageData) => {
    try {
        await addDoc(collection(db, "messages"), {
            ...messageData,
            timestamp: new Date().toISOString(),
        });
        return true;
    } catch (error) {
        console.error("Error saving message to Firestore:", error);
        return false;
    }
};
